import axios from 'axios';

import { Notistack } from '@shared/components/Notistack/Notistack';
import { SERVICES } from '@shared/constants/apiConfig';
import { getError } from '@shared/utils/helpers';

import { IDealCalculatorRequest, ILendersResponse, ISaveDealCaldData } from '../interfaces';

const BASE_URL = `/${SERVICES.LEAD}/leads/`;

export const requestSaveDealCalculator = async(data: ISaveDealCaldData, leadId: string) => {
  const path = `${BASE_URL}${leadId}/dealcalculator/save`;
  try {
    const resp = await axios.post(path, data);
    Notistack.successMessage('Deal Calculator - Saved Successfully');

    return resp;
  } catch (err) {
    Notistack.generalError(getError(err));
  }
};
export interface SwapBorrowerRequest {
  leadIds: string[];
  assetId: string;
  coContactId: string;
  contactId: string;
  coContactNumericId: number;
  dealId: string;
}

export const requestSwapCoBorrower = async(
  swapRequest: SwapBorrowerRequest
) => {
  try {
    const resp = await axios.post(`${BASE_URL}swap`, swapRequest);
    Notistack.successMessage('Coborrower swapped successfully');

    return resp;
  } catch (err) {
    Notistack.generalError(getError(err));
  }
};

export const requestGetDealCalculatorData = async(leadId: string, requestConfig: IDealCalculatorRequest) => {
  try {
    const resp = await axios.post<ILendersResponse>(`${BASE_URL}${leadId}/dealcalculator`, requestConfig);

    return resp.data;
  } catch (err) {
    Notistack.generalError(getError(err));
  }
};
